export const setValidationCalcState = (state, action): any => {
  const updatedState = {
    ...state,
    validateCalcStatus: action.payload.validateCalcStatus,
  };

  return updatedState;
};
